<template>
  <div class="project-statistics--ranking" v-if="rankings.length > 0 && ready">
    <div class="ranking" :class="computedRankingClass(ranking)" v-for="ranking in rankings" :key="ranking.position">
      <div class="ranking--position">
        {{ranking.position}}
      </div>
      <div class="ranking--user">
        {{ranking.user.display_name}}
        <div class="ranking--user-count" v-if="ranking.position == 1">
          {{ranking.leads_count}} {{$t('statistics.leads')}}
        </div>
      </div>
      <div class="ranking--count">
        {{ranking.leads_count}}
      </div>
      <div class="ranking--percentage">
        <progress-bar
          :percentage="formatPercentage(ranking.ranking_percentage)"
          :title="formatPercentage(ranking.ranking_percentage) + '%'"
          :is-mini="true" />
      </div>
    </div>
  </div>
  <div class="project-statistics--ranking is-empty" v-else>
    {{$t('statistics.no_data')}}
  </div>
</template>
<script>
import ProgressBar from '@/components/helpers/DataDisplay/ProgressBar'

export default{
  components: { ProgressBar },
  props: ['rankings'],
  data(){
    return {
      ready: false,
      current_user_id: null
    }
  },
  mounted(){
    this.current_user_id = this.$store.state.current_user.user_id
    if(this.rankings.length > 0){
      this.initComputedPercentages()
    }
  },
  methods: {
    computedRankingClass(ranking){
      let str = 'ranking-' + ranking.position
      if(ranking.user.id == this.current_user_id){
        str += ' is-myself'
      }
      return str
    },
    formatPercentage(number){
      return Math.round(number*100)
    },
    initComputedPercentages(){
      let maxPercentage = this.formatPercentage(this.rankings[0].ranking_percentage)
      let minPercentage = this.formatPercentage(this.rankings[this.rankings.length - 1].ranking_percentage)

      let factor = 100 / (maxPercentage - minPercentage)
      let maxOutput = 80
      let minOutput = 5
      let outputFactor = (maxOutput - minOutput) / 100

      this.rankings.forEach(element => {
        let percentage = this.formatPercentage(element.ranking_percentage)
        let outputPercentage = this.computedPercentage(percentage, factor, minPercentage)

        let outputPercentageBase = (this.formatPercentage(outputPercentage) * outputFactor) + minOutput
        element.computed_percentage = (outputPercentageBase)
      })

      this.ready = true
    },
    computedPercentage(value, factor, minPercentage){
      return (value - minPercentage) * factor / 100
    }
  },
  watch: {
    rankings(){
      this.ready = false
      if(this.rankings.length > 0){
        this.initComputedPercentages()
      }
    }
  }
}
</script>
<style lang="scss">
.ranking{
  display: flex;
  border-bottom: 1px solid #eaeaea;
  height: 45px;
  align-items: center;
  padding: 0 75px;
  &.is-myself{
    background-color: #f1efef;
  }
}

.ranking--position,
.ranking--user,
.ranking--position,
.ranking--percentage{
  padding: 5px;
  font-size: 16px;
  flex-shrink: 0;
  flex-basis: 0;
}

.ranking-1{
  height: 85px;
  border-bottom: 0;
  background-repeat: no-repeat;
  background-position: 20px center;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="48" height="44" viewBox="0 0 48 44"><g fill="#F8D200" fill-rule="nonzero"><path d="M39.5 2.3V.9H8.4v1.4c0 17.9 6.3 22.7 10.5 25.9 2.4 1.9 3.6 2.9 3.6 5.1v4.3c-2.3.2-4.5 1.1-5.3 2.8H14c-1.6 0-2.8 1.3-2.8 2.8h25.4c0-1.6-1.3-2.8-2.8-2.8h-3.2c-.8-1.7-3-2.5-5.3-2.8v-4.3c.1-2.3 1.3-3.3 3.7-5.1 4.2-3.2 10.5-8.1 10.5-25.9z"/>       <path d="M15.3 24.8C15.1 24.8 0 21.6 0 5.1V3.7h9.9v2.8h-7c.8 13 12.8 15.5 12.9 15.6l-.5 2.7M32.7 24.8l-.6-2.8c.5-.1 12.1-2.6 12.9-15.6h-7V3.6h10V5c0 16.6-15.1 19.8-15.3 19.8"/></g></svg>');
  .ranking--position,
  .ranking--user,
  .ranking--position{
    font-size: 36px;
    font-weight: 600;
  }
  .progress-bar .progress-bar--progression{
    background: #1B88FD;
  }
}

.ranking:last-child{
  border-bottom: none;
}

.ranking--position{
  flex-grow: 1;
  text-align: right;
  padding-right: 40px;
}
.ranking--user{
  flex-grow: 10;
  .ranking--user-count{
    display: none;
  }
}
.ranking--count{
  flex-grow: 1;
  font-weight: 400;
}
.ranking--percentage{
  flex-grow: 6;
  text-align: left;
  font-size: 16px;
  .progress-bar-container{
    display: flex;
    align-items: center;
    justify-content:flex-start;
    padding-left: 10px;
  }
  .progress-bar--title{
    order: 2;
    padding: 0px 15px;
    width: 10%;
    font-size: 12px;
  }
  .progress-bar{
    order: 1;
    margin-bottom: 0;
    width: 90%;
    margin-right: 10px;
    box-shadow: none;
    border-radius: 0px;
    align-self: center;
  }
  .progress-bar--progression{
    border-radius: 0;
    height: 12px;
  }
}

@include respond-to("medium"){
  .ranking{
    padding: 0;
  }
  .ranking--percentage{
    flex-grow: 0;
    text-align: right;
    .progress-bar--title{
      color: #000;
      font-size: 14px;
      padding: 0;
    }
    .progress-bar{
      display: none;
    }
  }
  .ranking--count{
    flex-grow: 0;
  }
  .ranking--user{
    flex-grow: 16;
  }
  .ranking-1{
    background-position: 1px center;
    .ranking--user{
      font-size: 24px;
      padding-left: 15px;
      .ranking--user-count{
        display: block;
        font-weight: 400;
        font-size: 18px;
      }
    }
    .ranking--position{
      visibility: hidden;
      font-size: 16px;
    }
    .ranking--count{
      visibility: hidden;
      display: none;
    }
  }

}
</style>



// WEBPACK FOOTER //
// ProjectStatisticsRanking.vue?3ef84110